import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  CommunicationWay,
  DeviceResponseType,
  DeviceType,
  IDevice,
  IDeviceResponseTypeInfo,
} from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { IDeviceUpdateInfo } from 'lavva.exalushome/build/js/Services/Updates/IUpdateInfo';
import { IconArrowLink } from '../../../../../../assets/icons/icon-arrow-link';
import { Checkbox } from '../../../../../../components';
import { ROUTES } from '../../../../../../routes/routes';
import { DeviceConnectionQuality } from '../../../../components/device/connection-quality';
import { DeviceIcon } from '../../../../components/device/icon';
import { useDeviceListContext } from '../../context';
import './index.scss';

type DeviceItemProps = {
  device: IDevice;
  update?: IDeviceUpdateInfo;
};

const DeviceItem: React.FC<DeviceItemProps> = ({ device, update }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const { updateMode, selectedDeviceIds, toggleDevice } = useDeviceListContext();

  const handleDeviceClick = () => {
    if (updateMode) return;

    navigate(ROUTES.DeviceSettings(device.Guid), { state: { back: 1 } });
  };

  const isChecked = useMemo(() => !!selectedDeviceIds.find((x) => x === device.Guid), [selectedDeviceIds, device.Guid]);

  return (
    <div className="driver__exalus m-b-24">
      <div className="driver__exalus--link" onClick={handleDeviceClick}>
        {updateMode ? (
          <Checkbox checked={isChecked} onChange={() => toggleDevice(device.Guid)} className="m-b-0 m-r-24" />
        ) : (
          <DeviceIcon iconType={device.IconType} />
        )}

        <h4 className="driver__exalus--header">
          <div className="driver__exalus--header-title">
            <div className="driver__exalus--header-title-name text-ellipsis">{device.Name}</div>
            <div className="driver__exalus--header-title-type">{`${t(
              `types.exalus.${DeviceType[device.DeviceType]}`,
            )} ${device.Model}`}</div>
          </div>
        </h4>
        <div className="signal-update-container">
          {device.AvailableResponseTypes?.any(
            (a: IDeviceResponseTypeInfo) => a.Type === DeviceResponseType.SignalStrength,
          ) && device.CommunicationWay !== CommunicationWay.OneWay ? (
            <DeviceConnectionQuality device={device} />
          ) : null}
          {update ? (
            <p className="exalus-version">
              <span>{update.CurrentResourceVersion}</span>
              <IconArrowLink size={10} className="icon-arrow-link--accent" /> <span>{update.NewResourceVersion}</span>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DeviceItem;
